import GreetingForm from "./GreetingForm";

export default GreetingForm